module.exports = __webpack_public_path__ + "img/heavy-hauler-no.1402cb0b.svg";